import { BaseModel } from "./BaseModel";
import { CalculationHelper, CalculationModel } from "./CalculationHelper";
import { CalcualtionResultKeys, ColumnHeaders, TabNames } from '../modules/Constants';

export class BusinessCaseComparisonModel extends BaseModel {
    overrideFormatSheet() {
        let header = this.Headers;
        let rows = this.Display;
        let columns = Array(rows[0].length).fill(0).map(() => ({ width: 150, numeric: false }));
        let blankRows = header.map((h, index) => { return { index: index, header: h } }).filter(item => item.header === "").map(item => item.index);
        columns[0].width = 300;

        let result = {}
        result.rows = rows.map(
            (row, rowIndex) => {
                let result = {}
                result.cells = columns.map((column, colIndex) => {
                    let cell = {};

                    if (colIndex === 0 && blankRows.includes(rowIndex) === false) {
                        cell = {
                            style: this.defaultHeader(),
                            wrap: true
                        }
                    } else {
                        if (rowIndex >= 4 && colIndex >= 1) {
                            if (rowIndex === 17 || rowIndex === 18 || rowIndex === 23 || rowIndex === 24) {
                                cell = {
                                    style: this.defaultCell(),
                                    format: '0.00%',
                                    wrap: true
                                }
                            } else {
                                cell = {
                                    style: this.defaultCell(),
                                    format: '#,##0.00',
                                    wrap: true
                                }
                            }
                        } else {
                            cell = {
                                style: this.defaultCell(),
                                wrap: true
                            }
                        }
                    }

                    let value = rows[rowIndex][colIndex] ?? "";

                    if (value[0] === '=') {
                        cell.formula = value;
                    } else {
                        cell.value = value;
                    }

                    return cell;
                })
                return result;
            })

        result.columns = columns.map((col) => ({ width: col.width }));

        return result
    }

    constructor() {
        super();
        this.TabName = TabNames.BUSINESS_CASE_COMPARISON;
        this.TabIndex = 1;
        this.DataProcessor = new BusinessCaseComparisonProcessor();
        this.formatSheet = this.overrideFormatSheet;
    }
}

export class BusinessCaseComparisonProcessor {
    process(_data) {

        let headers = this.configureHeader()

        let data = _data.map(x => Object.assign({}, x));
        data.currency = _data.currency;

        data.forEach(set => {
            let calculations = []
            let currency = data.currency;
            let exchangeRates = [];

            set.study.exchangeRates.forEach(rate => {
                rate.Item2.Values.forEach(item => {
                    exchangeRates.push({
                        currency: rate.Item1,
                        year: new Date(item.Date).getUTCFullYear(),
                        value: item.Value
                    });
                });
            });

            set.calculations_parsed[1].forEach(calc => {
                calculations.push(new CalculationModel(calc.calculationText, calc.calculation, calc.val, calc.amount, exchangeRates, currency))
            })

            set.calculations_parsed = calculations;
        })


        let records = this.setRecords(data);


        let result = {
            headers: headers,
            display: this.getDisplay(headers, records),
            numerics: this.getNumerics()
        };

        return result;
    }

    setRecords(data) {
        let records = [];
        data.forEach(dataset => {
            dataset.snapshots.forEach(snapshot => {
                records.push(new BusinessCaseComparisonRowModel(dataset.version, snapshot, dataset.calculations_parsed));
            })
        })

        return records;
    }

    configureHeader() {
        let header = [
            ColumnHeaders.COST_STUDY,
            ColumnHeaders.VERSION,
            ColumnHeaders.OPTION_NAME,
            "",
            ColumnHeaders.LTV,
            ColumnHeaders.LTR,
            ColumnHeaders.APRs,
            ColumnHeaders.NCPs,
            ColumnHeaders.GrossInvst,
            ColumnHeaders.Rebill,
            ColumnHeaders.NetInvst,
            ColumnHeaders.NetCapital,
            ColumnHeaders.ED_AND_T,
            ColumnHeaders.ED_AND_T_REBILL,
            ColumnHeaders.NET_ED_AND_T,
            ColumnHeaders.FWL,
            ColumnHeaders.OIAmount,
            ColumnHeaders.OIPercent,
            ColumnHeaders.IRR,
            ColumnHeaders.NPV,
            "",
            ColumnHeaders.REACH,
            "",
            ColumnHeaders.MATERIAL_TO_SALES,
            ColumnHeaders.MFG_RATE_TO_SALES,
            ColumnHeaders.AVG_SALES_PRICE_PER_PC,
            ColumnHeaders.AVG_MATERIAL_PER_PC
        ];

        return header;
    }

    getDisplay(headers, records) {
        let display = [];
        display.push(headers);

        records.forEach(record => {
            let row = [];

            row.push(
                record.CostStudy,
                record.Version,
                record.Option,
                "",
                record.LTV,
                record.LTR,
                record.APRs,
                record.NCPs,
                record.GrossInvst,
                record.Rebill,
                record.NetInvst,
                record.NetCapital,
                record.EDAndT,
                record.EDAndTRebill,
                record.NetEDAndT,
                record.FWL,
                record.OIAmount,
                record.OIPercent,
                record.IRRPercent,
                record.NPV,
                "",
                record.Reach,
                "",
                record.MaterialToSales,
                record.MfgRateToSales,
                record.AvgSalesPricePerPc,
                record.AvgMaterialPerPc
            )

            display.push(row);
        })


        return display[0].map((_, colIndex) => display.map(row => row[colIndex]));
    }

    getNumerics() {
        let numeric = [];

        return numeric;
    }

}

export class BusinessCaseComparisonRowModel {
    CostStudy = "";
    Version = "";
    Option = "";
    LTV = 0;
    LTR = 0;
    APRs = "";
    NCPs = "";
    GrossInvst = 0;
    Rebill = 0;
    NetInvst = 0;
    NetCapital = 0;
    EDAndT = 0;
    EDAndTRebill = 0;
    NetEDAndT = 0;
    FWL = 0;
    OIAmount = 0;
    OIPercent = "";
    IRRPercent = ""; 
    NPV = 0;
    Reach = 0;
    MaterialToSales = "";
    MfgRateToSales = "";
    AvgSalesPricePerPc = 0;
    AvgMaterialPerPc = "";
    FactoryCostMaterialFreightDuty = 0;
    FactoryCostInboundFreight = 0;
    FactoryCostInboundDuty = 0;
    TotalRevenueOutsideProductSales = 0;
    FactoryCostExpendablePackagingForSaleableProduct = 0;
    FactoryCostDirectLabor = 0;
    FactoryCostTotalBurdenwoDirectLabor = 0;
    FactoryCostMiscellaneousManufacturingPieceCost = 0;
    Manufacturing = 0;
    Material = 0;

    constructor(version, option, calculations) {
        let calculationHelper = new CalculationHelper();

        this.CostStudy = version.ECRNumber.Value.Fields[0];
        this.Version = version.Name;
        this.Option = option.GroupName;

        let materialAprList = version?.Adjustments?.map(x => x)?.filter(x => x?.Type?.Case === CalcualtionResultKeys.MATERIAL_APRS).map(x => x?.Adjustments[0]?.Value?.Fields)[0]?.reduce(function (a, b) { return a.concat(b) }, []);
        let ncpList = version?.Adjustments?.map(x => x)?.filter(x => x?.Type?.Case === CalcualtionResultKeys.NCPS).map(x => x?.Adjustments[0]?.Value?.Fields)[0]?.reduce(function (a, b) { return a.concat(b) }, []);

        this.APRs = materialAprList?.filter(x => x?.Date !== undefined).map(x => new Date(x?.Date).getUTCFullYear() + " x " + x?.Value).join(" , ");
        this.NCPs = ncpList?.filter(x => x?.Date !== undefined).map(x => new Date(x?.Date).getUTCFullYear() + " x " + x?.Value).join(" , ")

        let netCashFlow = {};

        option?.SaleableParts.forEach(part => {
            let partNumber = part.Part.Number.Fields[0];
            let partRev = part.Part.DrawingRevision?.Fields[0]?.Fields[0] ?? "";
            let partSuffix = part.Part?.Suffix?.Fields[0]?.Fields[0] ?? "";
            //-- Get Calculations for Part
            let partData = calculations.filter(item => { return item.partNumber === partNumber && item.partRev === partRev && item.partSuffix === partSuffix && item.groupName === option.GroupName })

            //-- Get Volumes
            let partkey = new CalculationHelper().getPartKey(part);
            let volumes = [];
            volumes[partkey] = { first: 0, total: 0 };

            volumes[partkey].first = part.CostStudyVolume.Value.Fields[0].Values[0].Value;

            part.CostStudyVolume.Value.Fields.forEach(volume => {
                volume.Values.forEach(value => {
                    volumes[partkey].total += value.Value;
                });
            });

            let totalVolume = calculationHelper.getNumber(part.LifetimeVolume);
            this.LTV += calculationHelper.getNumber(totalVolume);
            this.LTR += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.TOTAL_REVENUE }]));
            this.GrossInvst += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.GROSS_INVEST, line: CalcualtionResultKeys.GROSS_INVEST }]));
            this.Rebill += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOOLING_REBILL, line: CalcualtionResultKeys.TOOLING_REBILL }]));
            this.NetInvst += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.NET_INVEST, line: CalcualtionResultKeys.NET_INVEST }]));
            this.NetCapital += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.NET_CAPEX, line: CalcualtionResultKeys.NET_CAPEX }]));
            this.FWL += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.FORWARD_LEVERAGE }]));
            this.OIAmount += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.OPERATING_INCOME, line: CalcualtionResultKeys.OPERATING_INCOME }]));
            this.NPV += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.DISCOUNTED_CASH_FLOW, line: CalcualtionResultKeys.DISCOUNTED_CASH_FLOW }]));
            this.EDAndT += (calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TAXABLE_INCOME, line: CalcualtionResultKeys.ENGINEERING }])) * -1);
            this.EDAndTRebill += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.ENGINEERING_REBILL }]));
            this.Material += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL }]));
            this.FactoryCostMaterialFreightDuty += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL_AND_FREIGHT_DUTY }]));
            this.FactoryCostInboundFreight += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_FREIGHT }]));
            this.FactoryCostInboundDuty += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_DUTY }]));
            this.TotalRevenueOutsideProductSales += calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.OUTSIDE_PRODUCT_SALES }]));
            this.FactoryCostExpendablePackagingForSaleableProduct = calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.EXPENDABLE_PACKAGING_FOR_SALEABLE_PRODUCT }]));
            this.FactoryCostDirectLabor = calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.DIRECT_LABOR }]));
            this.FactoryCostTotalBurdenwoDirectLabor = calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.TOTAL_BURDEN_WO_DIRECT_LABOR }]));
            this.FactoryCostMiscellaneousManufacturingPieceCost = calculationHelper.getNumber(calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MISCELLANEOUS_MANUFACTURING_PIECE_COST }]));

            this.Reach += calculationHelper.getNumber(calculationHelper.totalCalculationIgnoreNegatives(partData, [{ key: CalcualtionResultKeys.CASH_FLOW_FROM_OPERATIONS, line: CalcualtionResultKeys.REACH }]));


            let partNetCashFlow = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.NET_CASH_FLOW, line: CalcualtionResultKeys.NET_CASH_FLOW }]);
            for (var key in partNetCashFlow) {
                netCashFlow[key] = calculationHelper.getNumber(netCashFlow[key] ?? 0) + calculationHelper.getNumber(partNetCashFlow[key] ?? 0);
            }
        });

        let arrNetCashFlow = [];
        for (var key in netCashFlow) {
            arrNetCashFlow.push(netCashFlow[key]);
        }

        this.IRRPercent = calculationHelper.irr(arrNetCashFlow);


        this.OIPercent = calculationHelper.getNumber(this.OIAmount / this.LTR);
        this.AvgSalesPricePerPc = calculationHelper.getNumber(this.LTR / this.LTV);
        this.NetEDAndT = this.EDAndT - this.EDAndTRebill;
        if (this.Material == 0 || this.Material == undefined) {
            this.Material = calculationHelper.getNumber(this.FactoryCostMaterialFreightDuty - (this.FactoryCostInboundDuty + this.FactoryCostInboundFreight));
        }
        this.Manufacturing = calculationHelper.getNumber(this.FactoryCostExpendablePackagingForSaleableProduct + this.FactoryCostDirectLabor + this.FactoryCostTotalBurdenwoDirectLabor + this.FactoryCostMiscellaneousManufacturingPieceCost);
        this.MaterialToSales = calculationHelper.getNumber(this.Material / this.TotalRevenueOutsideProductSales);
        this.MfgRateToSales = calculationHelper.getNumber(this.Manufacturing / this.TotalRevenueOutsideProductSales);
        this.AvgMaterialPerPc = calculationHelper.getNumber(this.Material / this.LTV);
    }
}
